import * as React from 'react';
const Anchor = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 122.34 122.88"
		{...props}
	>
		<path
			fill="#fff"
			d="M53.02 109.84V66.65H32.81V53.42h20.22V37.47c-7.36-2.73-12.6-9.82-12.6-18.13C40.42 8.66 49.08 0 59.76 0 70.44 0 79.1 8.66 79.1 19.34c0 8.31-5.24 15.39-12.6 18.13v15.96h20.22v13.23H66.5v43.2c11.87-1.58 23.74-7.35 35.62-17.32L91.58 82h30.76v30.76l-11.54-11.54c-33.15 28.48-66.65 28.86-100.48 1.22L0 112.76V82h30.76l-11.8 11.8c11.35 9.18 22.71 14.52 34.06 16.04zM59.76 7.89c6.32 0 11.45 5.13 11.45 11.45 0 6.32-5.13 11.45-11.45 11.45-6.32 0-11.45-5.13-11.45-11.45 0-6.32 5.13-11.45 11.45-11.45z"
			style={{
				fillRule: 'evenodd',
				clipRule: 'evenodd',
			}}
		/>
	</svg>
);
export default Anchor;
